import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { BaseFormDialogComponent } from "@hub/common/BaseFormDialogComponent";
import { Constants } from "@hub/common/Constants";
import { Functions } from "@hub/common/Functions";
import { eActionState, eContactType, eSearchContactType } from "@hub/generated/enums";
import {
  AssociateDto,
  ContactCardDto,
  SearchContactsOptions
} from "@hub/generated/models";
import { SearchController } from "@hub/generated/services";
import {
  FormEventService,
  FormService,
  NotificationService,
  PageLoaderService
} from "@hub/services/index";
import { ConfirmationService } from "primeng/api";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "hub-associate-dialog",
  templateUrl: "./associate-dialog.component.html",
  providers: [FormService]
})
export class AssociateDialogComponent extends BaseFormDialogComponent
  implements OnInit, OnDestroy {
  constructor(
    public fb: FormBuilder,
    public formService: FormService,
    public formEventService: FormEventService,
    public notificationService: NotificationService,
    public pageLoaderService: PageLoaderService,
    public confirmationService: ConfirmationService,
    public searchController: SearchController
  ) {
    super(
      fb,
      formService,
      formEventService,
      notificationService,
      pageLoaderService,
      confirmationService
    );
  }

  @Input()
  id: string = Constants.GUID_EMPTY;
  @Input()
  isNew: boolean;
  @Input()
  formData: any;
  @Input()
  isSuccessAddEdit: boolean = true;
  @Output()
  formUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSaveAssociate: EventEmitter<any> = new EventEmitter<any>();
  public display: boolean;
  public isFormEdit: boolean;
  public contactNameSuggestions: ContactCardDto[] = [];

  ngOnInit() {
    this.onInit();
  }

  ngOnDestroy() {
    this.onDestroy();
  }

  public formInit(): void {

    this.isFormEdit = false;
    this.formService.formEdit(false);
    this.formGroup = this.fb.group({
      id: !this.isNew ? this.formData[0].Id : Constants.GUID_EMPTY,
      contact: !this.isNew
        ? [
            {
              FullName: this.formData[0].Contact.FullName,
              Id: this.formData[0].Contact.Id
            },
            Validators.compose([Constants.notObject])
          ]
        : ["", Validators.compose([Constants.notObject])],
      comment: !this.isNew ? this.formData[0].Comment : [""]
    });

    this.formGroup.valueChanges
      .pipe(takeUntil(this.ngInitUnsubscribe))
      .subscribe((x: any) => {
        if (this.isFormEdit === false) {
          this.formService.formEdit(true);
          this.isFormEdit = true;
        }
      });


  }

  public saveActionHandler(e: any): void {
    this.onSaveAssociate.emit(this.getAssociationFormValues());
    if (this.isSuccessAddEdit) {
      this.displayChange.emit(false);
      this.formUpdated.emit();
      this.hide();
    }
  }

  public onAcceptConfirmationHandler(): void {
    this.hide();
    this.displayChange.emit(false);
  }

  public onCloseInvalidFormHandler(): void {
    this.hide();
    // this.pageLoaderService.takePageLoader();
  }

  public formValueChangeHandler(data: any): void {
    this.assocsFormValueChangeHandler(data);
  }

  public assocsFormValueChangeHandler(data) {
    this.isFormEdit = true;
    this.formService.formEdit(true);
  }

  public getContactsDto(event) {

       let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
       searchParameters.Types = [eSearchContactType.Contact]

      this.searchController
        .SearchContacts(searchParameters)
        .pipe(takeUntil(this.ngInitUnsubscribe))
        .subscribe(data => {
          this.contactNameSuggestions = data;
        });
  }

  private getAssociationFormValues(): AssociateDto {
    const val = this.formGroup.value;

    const editAssociation: AssociateDto = {
      RecordId: this.id,
      Id: val.id,
      ContactId: val.contact.Id,
      Comment: val.comment,
      Name: "",
      Company: "",
      Contact: null,
      ContactType:'',
      ContactTypeId: eContactType.Not_Set,
      CreatedById: Constants.GUID_EMPTY,
      CreatedOn: new Date(),
      ActionState: !this.isNew ? eActionState.Changed : eActionState.Inserted,
      ModifiedById: Constants.GUID_EMPTY,
      ModifiedOn: new Date()
    };
    return editAssociation;
  }
}
